export const DESIGN_SYSTEM = {
  colors: {
    primary: {
      50: '#eef2ff',
      100: '#e0e7ff',
      500: '#6366f1',
      600: '#4f46e5',
      700: '#4338ca',
      900: '#1e1b4b',
    },
    neutral: {
      background: 'bg-[#f6f7fb]',
      surface: 'bg-white',
      border: 'border-slate-200/80',
      textPrimary: 'text-slate-900',
      textSecondary: 'text-slate-500',
    }
  },
  status: {
    ACTIF: {
      label: 'Actif',
      badge: 'bg-emerald-50 text-emerald-700 border-emerald-200',
      dot: 'bg-emerald-500',
    },
    EN_ATTENTE: {
      label: 'En attente',
      badge: 'bg-amber-50 text-amber-700 border-amber-200',
      dot: 'bg-amber-500',
    },
    INACTIF: {
      label: 'Inactif',
      badge: 'bg-slate-100 text-slate-600 border-slate-200',
      dot: 'bg-slate-400',
    },
    EXPIRE: {
      label: 'Expiré',
      badge: 'bg-orange-50 text-orange-700 border-orange-200',
      dot: 'bg-orange-500',
    },
    ERREUR: {
      label: 'Erreur',
      badge: 'bg-rose-50 text-rose-700 border-rose-200',
      dot: 'bg-rose-500',
    },
    PREPARATION: {
      label: 'Préparation',
      badge: 'bg-blue-50 text-blue-700 border-blue-200',
      dot: 'bg-blue-500',
    },
    SUSPENDU: {
      label: 'Suspendu',
      badge: 'bg-orange-50 text-orange-700 border-orange-200',
      dot: 'bg-orange-500',
    },
    REVOQUE: {
      label: 'Révoqué',
      badge: 'bg-rose-50 text-rose-700 border-rose-200',
      dot: 'bg-rose-500',
    },
  }
};

export const STATUS_ALIAS = {
  succes: 'ACTIF',
  success: 'ACTIF',
  actif: 'ACTIF',
  active: 'ACTIF',
  operational: 'ACTIF',
  operationnel: 'ACTIF',
  echec: 'ERREUR',
  error: 'ERREUR',
  erreur: 'ERREUR',
  refuse: 'ERREUR',
  refused: 'ERREUR',
  en_attente: 'EN_ATTENTE',
  pending: 'EN_ATTENTE',
  waiting: 'EN_ATTENTE',
  inactif: 'INACTIF',
  inactive: 'INACTIF',
  suspendu: 'SUSPENDU',
  suspended: 'SUSPENDU',
  expire: 'EXPIRE',
  expired: 'EXPIRE',
  preparation: 'PREPARATION',
  revoque: 'REVOQUE',
  revoked: 'REVOQUE',
  neutre: 'INACTIF',
};
